import styled from 'styled-components';
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const FilterButtonDefaultBox = styled.a`
    width: 125px;
    height: 32px;
    background: ${({theme}) => theme.colors.textDark};
    border: 2px solid ${({theme}) => theme.colors.textDark};
    opacity: 1;
    margin: 2px;
    padding: 15px;
    align-items: center;
    display: flex;
    justify-content: center;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);

    white-space: normal;
    text-align: center;
    font-size: 11px;
    letter-spacing: -0.03em;
    line-height: normal;
    color: ${({theme}) => theme.colors.textHover};
    ${({theme}) => theme.font.presets.regular};
    opacity: 1;

    &:hover, &:active, &:focus {
        color: ${({theme}) => theme.colors.textHover};
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
    }

    &.${ACTIVE} {
        border-color: ${({theme}) => theme.colors.brandPrimary};
        color: ${props => props.theme.colors.brandPrimary};
        ${({theme}) => theme.font.presets.bold};
    }
`;